/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

import { lightTheme } from "src/app/themes";

export const StandardInput = styled.input<{ alwaysLightMode?: boolean }>`
  overflow: visible;
  margin: 0;
  -webkit-appearance: none;
  box-sizing: border-box;
  height: calc(1.5rem + 15px);
  line-height: 1.5rem;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, Roboto, Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  border-width: 1px;
  border-style: solid;
  border-color: #e6e6e6;
  width: 100%;
  padding: 12px;
  outline: 0;
  transition: box-shadow 100ms ease-in-out 0s;
  color: ${({ theme, alwaysLightMode }) => (alwaysLightMode ? lightTheme.text.default : theme.text.default)};
  background-color: ${({ theme, alwaysLightMode }) =>
    alwaysLightMode ? lightTheme.background : theme.background};
  transition: box-shadow 100ms ease-in-out 0s;
  border-radius: 0px;
  :focus {
    box-shadow: inset 0 0 0px 2.5px
      ${({ theme, alwaysLightMode }) => (alwaysLightMode ? lightTheme.primary : theme.primary)};
  }
`;

export const EditProfileInput = styled.input`
  background-color: #eeeeee;
  font-family: "IBM Plex Mono", monospace;
  border: 0px;
  width: 100%;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
  padding: 10px 14px 10px 14px;
  &::placeholder {
    color: #a5a5a5;
  }
  margin-bottom: 20px;
  transition: box-shadow 100ms ease-in-out 0s;
  :focus {
    box-shadow: inset 0 0 0px 2px #000000;
  }
`;
